// extracted by mini-css-extract-plugin
export default {"gradientt":"Sidebar_gradientt__EB25c","gradinett":"Sidebar_gradinett__k4FH-"};